<template>
  <v-container fluid>
    <v-card class="shadowCard mt-6">

      <!-- Sección principal, el header de mi componente -->
      <v-card-title class="text-subtitle-1">

        <!-- Titulo de mi componente -->
        Estado de Cuenta Bancos Detalle
        <v-spacer></v-spacer>
        
        <!-- Botón para actualizar la plataforma -->
        <v-btn 
          color="primary"
          small
          dark
          @click="getReportesBancos( )"
        >
          Actualizar
          <v-icon right>mdi-update</v-icon>
        </v-btn>

      </v-card-title>


      <!-- Cuerpo de mi componente -->
      <v-card-text>

        <!-- Filtros principales -->
        <v-row justify="space-between">

          <!-- Filtro por banco -->
          <v-col cols="12" md="4" lg="3">
            <v-select
              v-model="bancoFilter"
              :items="bancoOptions"
              label="Banco"
              hide-details
              dense
              clearable
              filled
            ></v-select>
          </v-col>

          <!-- FILTRO POR TIPO -->
          <v-col cols="12" md="4" lg="3">
            <v-select
              v-model="tipoArchivo"
              :items="tiposArchivos"
              label="Tipo"
              hide-details
              dense
              clearable
              filled
            ></v-select>
          </v-col>

          <!-- Filtro por escuela -->
          <v-col cols="12" md="4" lg="3">
            <v-select
              v-model="escuelaFilter"
              :items="escuelaOptions"
              label="Escuela"
              hide-details
              dense
              clearable
              filled
              item-text="text"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="4" lg="3" xl="2">
            <v-text-field
              label="Fecha de incio"
              filled
              dense
              hide-details
              clearable
              v-model="fechaini"
              type="date"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="4" lg="3" xl="2">
            <v-text-field
              label="Fecha final"
              filled
              dense
              hide-details
              clearable
              v-model="fechafin"
              type="date"
            ></v-text-field>
          </v-col>

        </v-row>

        <!-- Apartado: Agregar saldo de la cuenta al día por escuela -->
        <v-row>
          <v-col cols="12">
            <v-alert
              type="info"
              outlined
              dense
              class="mb-0"
            >
              <span class="text-body-2">— Agregar saldo de la cuenta al día por escuela</span>
            </v-alert>
          </v-col>
        </v-row>
        
        <v-row>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
              filled
            ></v-text-field>
          </v-col>

          <v-col cols="12">

            <!-- Botón para validación multiple -->
            <!-- <v-btn 
              color="success" 
              outlined 
              v-if="ingresosSeleccionados.length" 
              @click="validacionMultiple( )"
            >
              Validar datos seleccionados
            </v-btn> -->
            
            <v-data-table
              :headers="headersReporte"
              :items="filteredResults"
              :search="search"
              class="elevation-0"
            >

              <!-- Oculta el checkbox del header (select all) -->
              <template v-slot:header.data-table-select></template>

              <!-- Sacar la información del banco -->
              <template v-slot:item.bancoArchivo="{ item }">
                <v-chip
                  small
                  :color="getBancoColor(item.bancoArchivo)"
                  text-color="white"
                  label
                >
                  {{ getBancoLabel(item.bancoArchivo) }}
                </v-chip>
              </template>


              <!-- Mostrar el tipo de archivo -->
              <template v-slot:item.tipoArchivo="{ item }">
                <v-chip
                  small
                  :color="getTipoArchivo(item.tipoArchivo)"
                  text-color="white"
                  label
                >
                  {{ item.tipoArchivo }}
                </v-chip>
              </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Snackbar para notificaciones -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />

  </v-container>
</template>

<script>
import axios from 'axios';
import * as XLSX from 'xlsx';

// Componentes
import Alerta         from "@/components/alertas/Alerta.vue";
import carga          from "@/components/alertas/carga.vue";
import validarErrores from "@/mixins/validarErrores";
import { mapGetters } from 'vuex'

export default {
  name: 'ValidationPanel',
  data() {
    return {

      // Alertas
      parametros: {
        dialogError: false,
        mensaje: "",
        color: "",
      },

      respuestaAlerta: false,
      loader: true,
      cargar: false,

      dialogAddReporte: false,

      tipoArchivo:null,
			tiposArchivos:['EDO CUENTA', 'TPV', 'COMERCIO ELECTRONICO'],

			bancoArchivo: null,
			bancosArchivos: ['BBVA', 'BANREGIO', 'HSBC'],

      excelIngresos: null,

      // Header estado de cuenta
      headersReporte: [
        { text: 'Fecha'       , value: 'fecha'         },
        { text: 'Banco'       , value: 'bancoArchivo'  },
        { text: 'Tipo'        , value: 'tipoArchivo'   },
        { text: 'Cargo'       , value: 'pago'          },
        { text: 'Abono'       , value: 'banco'         },
        { text: 'Concepto'    , value: 'concepto'      },
        { text: 'refer BNR'   , value: 'refer_bnr'     },

        { text: 'Refer HSBC 1'  , value: 'ref_hsbc_1'  },
        { text: 'Refer HSBC 2'  , value: 'ref_hsbc_2'  },
        { text: 'Refer HSBC 3'  , value: 'ref_hsbc_3'  },
      ],


      // Nuevos filtros
      bancoFilter: null,
      escuelaFilter: null,

      // Opciones para los nuevos filtros
      bancoOptions: ['BBVA', 'BANREGIO', 'HSBC'],
      escuelaOptions: [
        { text: 'Inbi', value: 1 },
        { text: 'Fast', value: 2 },
        { text: 'Todas', value: 3 }
      ],

      excelFile: null,
      loading: false,
      dbData: [],
      processedResults: [],
      search: '',

      snackbar: {
        show: false,
        text: '',
        color: '',
        timeout: 4000
      },

      ingresosSeleccionados:[],

      // Búsqueda desde detalles
      detailSearch: {
        referencia: '',
      },

      archivosLeidos:[],

      fechaini:null,
      fechafin:null,
      

      // LECTURA DE ARCHIVO
      opNomina: 1,
      dialogPDFDetalles: false,

      partidasNomina:[],
      archivoSeleccionado: null,
      dialgoValidaMultiple: false,
      dataMultiple: [],
      RX_ONLY_LEADING_DIGITS: /^\s*(\d+)/,
      RX_SPEI_NOMBRE: /^\s*\d{3}\s+\d+\s+(.+?)\s*$/,
      GENERICOS: new Set(['sin informacion', 'sin información', 'transferencia', 'pago', 'deposito', 'depósito', 'abono', 'sin datos', 'n/a', 'pendiente', 'traspaso', 'traspaso interno'])
    }
  },

  components: {
    Alerta,
    carga,
  },

  watch:{

    archivoSeleccionado ( value ){

      if( value ){

        this.archivosLeidosDetalle = value.detalles
      
        this.processExcel( )
      
      }
    }

  },


  created( ) {

  },

  mixins: [validarErrores],

  computed: {

    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    filteredResults() {
      let results = this.archivosLeidos

      // Filtrar por banco
      if ( this.bancoFilter) {
        results = results.filter( item => item.bancoArchivo == this.bancoFilter );
      }

      if( this.tipoArchivo ){
        results = results.filter( item => item.tipoArchivo == this.tipoArchivo );
      }

      // Filtrar por escuela (1=Inbi, 2=Fast, 3 o null=Todas)
      if ( this.escuelaFilter != null && this.escuelaFilter !== '' && this.escuelaFilter !== 3 ) {
        results = results.filter( item => (item.escuela || item.id_escuela) == this.escuelaFilter );
      }

      return results;
    },
  },

  methods: {

    getBancoColor(banco) {
      if (!banco) return 'grey';

      const bancoUpper = banco.toString().toUpperCase();
      if (bancoUpper.includes('BBVA') || bancoUpper.includes('BANCOMER')) return 'blue darken-1';
      if (bancoUpper.includes('BR') || bancoUpper.includes('BANREGIO')) return 'purple';
      if (bancoUpper.includes('SANTANDER')) return 'red darken-1';
      if (bancoUpper.includes('BANAMEX') || bancoUpper.includes('CITI')) return 'blue-grey';
      if (bancoUpper.includes('BANORTE')) return 'orange darken-1';
      if (bancoUpper.includes('HSBC')) return 'red';

      return 'green'; // Para otros bancos
    },

    getTipoArchivo(tipo) {
      if (!tipo) return 'grey';

      const bancoUpper = tipo.toString().toUpperCase();
      if (bancoUpper.includes('EDO CUENTA') || bancoUpper.includes('BANCOMER')) return 'green';
      if (bancoUpper.includes('TPV') || bancoUpper.includes('BANREGIO')) return 'purple';
      if (bancoUpper.includes('COMERCIO ELECTRONICO')) return 'yellow';

      return 'green'; // Para otros bancos
    },

    getBancoLabel(banco) {
      if (!banco) return 'N/A';

      const bancoUpper = banco.toString().toUpperCase();
      if (bancoUpper.includes('BBVA') || bancoUpper.includes('BANCOMER')) return 'BBVA';
      if (bancoUpper.includes('BR') || bancoUpper.includes('BANREGIO')) return 'BanRegio';
      if (bancoUpper.includes('SANTANDER')) return 'Santander';
      if (bancoUpper.includes('BANAMEX') || bancoUpper.includes('CITI')) return 'Banamex';
      if (bancoUpper.includes('BANORTE')) return 'Banorte';
      if (bancoUpper.includes('HSBC')) return 'HSBC';

      return banco; // Para otros bancos, mostrar el valor original
    },

    async getReportesBancos( ){

      this.cargar = true
      
      this.archivosLeidos = []
      // /*Initialize the form data*/
      

      if( !this.fechaini || !this.fechafin ){
      	return this.validarErrorDirecto('Porfavor ingresa un rango de fechas')
      }

      try {

      	let payload = {
      		fechaini: this.fechaini,
					fechafin: this.fechafin
      	}

        const response = await this.$http.post('reportes.bancos.detalles', payload);
        this.archivosLeidos = response.data

      } catch (error) {
        // 🔹 8. Manejo seguro del error (sin optional chaining)
        let msg = 'Ocurrió un error al procesar el archivo. Intente de nuevo.';

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          msg = error.response.data.message;
        }

        this.validarError(msg);

      } finally {
        // 🔹 9. Apagamos el loader siempre
        this.cargar = false;
      }

    },

  }
};
</script>

<style scoped>
.max-width-200 {
  max-width: 200px;
}
.text-success {
  color: #4caf50 !important;
}
.text-error {
  color: #f44336 !important;
}
.text-warning {
  color: #fb8c00 !important;
}
.cursor-pointer {
  cursor: pointer;
}
.text-wrap {
  white-space: normal;
  word-break: break-word;
  display: block;
}
.concepto-container {
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-all;
  user-select: all;
  cursor: text;
}
</style>
